import { shouldSkipColdSessionBootstrap } from '@/utils/sessionBootstrap';
import { notify } from '@/core/toast/notify';

let signingOut = false;

export function beginSignOut(): void {
  signingOut = true;
}

export function endSignOut(): void {
  signingOut = false;
}

export function isSigningOut(): boolean {
  return signingOut;
}

/** Suppress expected 401/403 noise during logout and on public auth pages. */
export function shouldSuppressAuthError(status?: number): boolean {
  if (status !== 401 && status !== 403) {
    return false;
  }
  if (signingOut) {
    return true;
  }
  if (typeof window !== 'undefined' && shouldSkipColdSessionBootstrap(window.location.pathname)) {
    return true;
  }
  return false;
}

const LOGIN_SUCCESS_DEDUPE_MS = 5000;
const recentLoginSuccess = new Map<string, number>();

/** Show a login success toast at most once per key within a short window. */
export function showLoginSuccessToast(message: string, key: string): void {
  const now = Date.now();
  const last = recentLoginSuccess.get(key);
  if (last != null && now - last < LOGIN_SUCCESS_DEDUPE_MS) {
    return;
  }
  recentLoginSuccess.set(key, now);
  notify.success(message);
}
